import { z } from 'zod';
import { trimmed } from './_fields.js';

/**
 * Post-it d'agenda. Le titre est le libellé affiché sur le créneau.
 * La durée est en minutes : le serveur calcule la fin, comme pour un rendez-vous.
 */

export const agendaNoteCreateSchema = z
  .object({
    title: trimmed(200),
    practitionerMemberId: z.uuid(),
    startsAt: z.iso.datetime(),
    durationMinutes: z.int().min(5).max(600).optional(),
  })
  .strict();
export type AgendaNoteCreateInput = z.infer<typeof agendaNoteCreateSchema>;

/** Règle de titre renvoyée avec une note, pour pouvoir l'oublier depuis le post-it. */
export interface AgendaNoteRuleRef {
  id: string;
  active: boolean;
}

export interface AgendaNoteRuleDto {
  id: string;
  label: string;
  active: boolean;
}
